<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section class="section--learn-more" id="scrollToOnLoad">
      <b-container>
        <b-row>
          <b-col sm="6" lg="5" xl="6">
            <div class="zoom-on-hover">
              <img class="img-fluid" src="static/assets/img-where_learn_more.jpg" alt="">
            </div>
          </b-col>
          <b-col sm="6" lg="6" xl="6"
            class="d-flex flex-column justify-content-center pl-lg-4">
          <h2 class="mt-4 mt-sm-1 mt-md-4 pb-2 pt-md-0 ">{{ content.title }}
            <span class="text--shadow-right">{{ content.title }}</span>
          </h2>
            <p class="text--small" v-html="content.content"></p>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section-figures :figures="resources" :btnText="btnText" itemColSize="4" id="resources">
    </section-figures>
    <b-pagination
        v-scroll-to="'#resources'"
        aria-controls="resources"
        size="md"
        :total-rows="totalRows"
        :per-page="9"
        @change="handlePageChange"
        class="mb-5 mt-0">
    </b-pagination>
    <section class="section--opinions" v-if="opinion[1]">
      <b-container>
        <b-row>
          <b-col md="8" offset-md="2">
            <div class="opinion">
              <p class="opinion__content">{{ opinion[1].quote }}</p>
            <span class="opinion__signature">{{ opinion[1].name }}</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import resources from '@/api/v1/learnMore';
import Hero from '@/components/Hero';
import Figures from '@/components/Figures';

export default {
  data() {
    return {
      bgImg: 'Banner1-I_Love_Science-',
      subtitle: this.$t('nav.iLoveScience'),
      page: 1,
      isLast: true,
      resources: [],
      btnText: 'Go to',
      content: {},
      opinion: {},
    };
  },
  components: {
    'section-hero': Hero,
    'section-figures': Figures,
  },
  methods: {
    getResources() {
      const succ = (response) => {
        this.resources = response.data.resources;
        this.isLast = response.data.is_last;
      };
      resources.index(this.page, succ);
    },
    getContent() {
      const succ = (response) => {
        this.content = response.data.where_learn_more;
      };
      resources.content(succ);
    },
    getOpinion() {
      const succ = (response) => {
        this.opinion = response.data.quotes_home;
      };
      resources.getOpinion(succ);
    },
    handlePageChange(value) {
      this.value = value;
      this.page = value;
    },
  },
  computed: {
    totalRows() {
      if (this.isLast) {
        return this.page * 9;
      }
      return (this.page + 1) * 9;
    },
  },
  created() {
    this.getResources();
    this.getContent();
    this.getOpinion();
  },
  watch: {
    page() {
      this.getResources();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';

.section {
  &--learn-more {
    padding-bottom: 100px;
    padding-top: 100px;
    @include media('<md') {
      padding: 40px 0;
    }
  }
  &--opinions {
    padding: 175px 0 118px;
    background-color: $color--orange;
    @include media('<lg') {
      padding: 100px 0 50px;
    }
  }
  &--news {
    padding: 100px 0;
    text-align: center;
  }
  &--figures {
    @include media('<md') {
      background-color: $color--white-1;
      padding-top: 40px;
    }
  }
}

.opinion {
  text-align: center;
  &__content {
    font-size: 20px;
    font-style: italic;
    font-family: Montserrat;
    color: $color--white;
    position: relative;
    text-align: center;
    margin-bottom: 15px;
    @include media('<md') {
      font-size: 14px;
    }
    &:before {
      content: url('../../assets/ico-quotation-mark.png');
      position: absolute;
      top: -40px;
      transform: translateX(-50%);
      left: 50%;
    }
  }
  &__signature {
    font-family: Montserrat;
    font-size: 20px;
    font-weight: 600;
     @include media('<md') {
      font-size: 14px;
    }
  }
}
.news {
  &__content{
    padding: 25px 5px;;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StaticPages/LearnMore.vue